/* eslint-disable no-shadow */
export enum ZapsignDocumentType {
	CONTRACT_52 = 'CONTRACT_52',
	CONTRACT_78 = 'CONTRACT_78',
	CONTRACT_104 = 'CONTRACT_104',
	CONTRACT_156 = 'CONTRACT_156',
	CONTRACT_1 = 'CONTRACT_1',
	PAGARE = 'PAGARE',
}

export enum ZapsignDocumentStatus {
	PENDING = 'pending',
	SIGNED = 'signed',
}
export const ZapsignDocumentStatusValues = {
	[ZapsignDocumentStatus.PENDING]: {
		label: 'Pendiente',
		color: 'yellow_100',
	},
	[ZapsignDocumentStatus.SIGNED]: {
		label: 'Firmado',
		color: 'green_300',
	},
};

export enum ZapsignSignerStatus {
	NEW = 'new',
	LINK_OPENED = 'link-opened',
	SIGNED = 'signed',
}
